import React from 'react';
import { useIntl } from 'react-intl';

import { Notification } from '@xsolla/ui-core';

import { HorizontalCenterBlock, ShortSettingsBlock } from '../../../styled';
import { FieldSelect, Notice } from '../../ui';
import { OrderDescription, OrderHeader, OrderNotification } from './style';
import { FormValues } from './types';

type Props = {
  values: FormValues;
};

export const AskOrderSelect = ({ values }: Props): JSX.Element => {
  const intl = useIntl();

  const orderOptions = [
    {
      children: intl.formatMessage({ id: 'miscellaneous.settings.order.email' }),
      value: 'email'
    },
    {
      children: intl.formatMessage({ id: 'miscellaneous.settings.order.phone' }),
      value: 'phone_number'
    }
  ];

  const isAllFieldsActive = () => !(values.email_collect && values.phone_number_collect);

  return (
    <HorizontalCenterBlock>
      <ShortSettingsBlock>
        <OrderHeader>
          {intl.formatMessage({ id: 'miscellaneous.settings.order.title' })}
        </OrderHeader>
        <OrderDescription>
          {intl.formatMessage({ id: 'miscellaneous.settings.order.subtitle' })}
        </OrderDescription>
        <OrderNotification>
          <Notification icon={Notice}>
            {intl.formatMessage({ id: 'miscellaneous.settings.order.notification' })}
          </Notification>
        </OrderNotification>
        <FieldSelect options={orderOptions} name="field_order" disabled={isAllFieldsActive()} />
      </ShortSettingsBlock>
    </HorizontalCenterBlock>
  );
};
